/*
Hinge Plates

  --thickness <float::enum> | millimeters | [0, 3, 6, 9, 18]
  --wedges <bool> | checkbox
*/
import hardwareFilters from '@/modules/standardItems/schemas/hardware/filters'

export default [
  ...hardwareFilters,
  {
    label: 'Thickness',
    value: 'thickness',
    type: 'list',
    returnObject: false
  },
  {
    label: 'Wedges',
    value: 'wedges',
    type: 'checkbox'
  }
]
